export default "__VITE_ASSET__C3IRtN3k__"